import { useEffect } from 'react';
import MainLayout from './MainLayout';
import { VerticalLayout } from '../common/common-layout';
import { observer } from 'mobx-react-lite';
import welcome from "../assets/icons/welcome.svg";
import { homeMenuStore } from '../store/HomeMenuStore';

const MainHome = () => {
    useEffect(() => {
        // MainHome 진입 시 메뉴 상태 초기화
        homeMenuStore.resetMenuState();
    }, []);
    
    return (
        <MainLayout isMainPage>
            <MainHomeBody />
        </MainLayout>
    );
};

export default MainHome;

const MainHomeBody = observer(() => {
    return (
        <VerticalLayout
            style={{
                flex: 1,
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >
            <img src={welcome} alt="Welcome" />
        </VerticalLayout>
    );
});